import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AccessDenied = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            maxWidth: 400,
            width: '100%',
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom color="error">
            Access Denied
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
            You do not have access to this service. Only administrators are allowed to access this platform.
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
            If you believe this is an error, please contact your system administrator.
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogout}
            fullWidth
            sx={{ mt: 2 }}
          >
            Return to Login
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied; 